import { render, staticRenderFns } from "./ContentByPage.vue?vue&type=template&id=611808bd&scoped=true&"
import script from "./ContentByPage.vue?vue&type=script&lang=js&"
export * from "./ContentByPage.vue?vue&type=script&lang=js&"
import style0 from "./ContentByPage.vue?vue&type=style&index=0&id=611808bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611808bd",
  null
  
)

export default component.exports